// Coupon lookup + validation for the cart and the seller's coupon form.
// Mirrors bloom-backend-ds/couponMatch.js (checkout re-validates with the same rules) — keep the two in sync.
// Matching ignores case AND all whitespace ("FREE SHIP" == "freeship"), skips inactive/expired coupons, and when a
// store has duplicate codes picks the one the cart qualifies for (best saving), never just the first.
export const normCode = (s) => String(s ?? "").replace(/\s+/g, "").toUpperCase();
const minOf = (c) => Number(c && c.min_order) || 0;
const worth = (c, subtotal) => {
  const v = Number(c.discount_value) || 0;
  return c.discount_type === "percent" ? (Number.isFinite(subtotal) ? subtotal * v / 100 : v) : Math.min(v, subtotal);
};

export function findCoupon(coupons, code, subtotal = Infinity, now = Date.now()) {
  const want = normCode(code);
  if (!want) return { coupon: null, reason: "invalid" };
  const live = (Array.isArray(coupons) ? coupons : []).filter((c) => c && c.active && normCode(c.code) === want);
  if (!live.length) return { coupon: null, reason: "invalid" };
  const unexpired = live.filter((c) => !c.expires_at || new Date(c.expires_at).getTime() >= now);
  if (!unexpired.length) return { coupon: null, reason: "expired" };
  const qualifies = unexpired.filter((c) => !(minOf(c) > 0) || subtotal >= minOf(c));
  const pool = qualifies.length ? qualifies : unexpired;
  const best = pool.reduce((a, b) => (worth(b, subtotal) > worth(a, subtotal) ? b : a));
  return { coupon: best, reason: null };
}

// Validate a coupon a seller is about to create. Returns an error string, or "" when fine.
export function couponFormError({ code, type, value, min }, existing = []) {
  if (!normCode(code)) return "Enter a coupon code.";
  const v = Number(value);
  if (!Number.isFinite(v) || v <= 0) return "The discount must be more than 0.";
  if (type === "percent" && v > 100) return "A percentage discount can't be more than 100%.";
  const m = Number(min);
  if (min !== "" && min != null && (!Number.isFinite(m) || m < 0)) return "Minimum order can't be negative.";
  if ((Array.isArray(existing) ? existing : []).some((c) => c && c.active && normCode(c.code) === normCode(code)))
    return "You already have an active coupon with this code. Delete or deactivate it first.";
  return "";
}
